import React from 'react';
import { Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { RadioGroupField } from 'components/form';
import { FormSectionHeader, FormSectionHeaderProps } from 'components/shared/FormSectionHeader';
import { LenderDeskingPanelFormValues } from '../../../types';
import { brandingTypeOptions, contactTypeOptions, ratePresentationOptions } from '../../../constants';

interface Props<Value extends string> extends FormSectionHeaderProps<Value> {
  isSectionDisabled?: boolean;
}

export const ProposalConfigurationSection = <Value extends string>({
  isSectionDisabled = false,
  ...headerProps
}: Props<Value>) => {
  const { control } = useFormContext<LenderDeskingPanelFormValues>();

  return (
    <Stack gap="1rem">
      <FormSectionHeader {...headerProps} />

      <Stack gap="1rem">
        <RadioGroupField
          row
          control={control}
          className="flexed-radio"
          label="Rate Presentation"
          disabled={isSectionDisabled}
          options={ratePresentationOptions}
          name="proposalSettings.ratePresentation"
        />

        <RadioGroupField
          row
          label="Contact"
          control={control}
          className="flexed-radio"
          disabled={isSectionDisabled}
          options={contactTypeOptions}
          name="proposalSettings.contact"
        />

        <RadioGroupField
          row
          label="Branding"
          control={control}
          className="flexed-radio"
          disabled={isSectionDisabled}
          options={brandingTypeOptions}
          name="proposalSettings.branding"
        />
      </Stack>
    </Stack>
  );
};
